/* RESPONSIBLE TEAM: team-reporting */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import { hash } from 'rsvp';
import ConversationAttributeDescriptor from 'embercom/models/conversation-attributes/descriptor';

export default class TeamInboxPerformanceReportRoute extends IntercomRoute {
  @service appService;
  @service store;
  @service reportingMetrics;
  @service intercomEventService;
  @service router;
  @service customReportsService;
  @service intercomEventService;

  analytics = {
    place: 'team_inbox_performance_report',
  };
  reportName = 'team-inbox-performance-report';
  reportContext = 'team_inbox';

  activate() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'viewed',
      object: this.reportName,
      context: this.reportContext,
    });
  }

  get app() {
    return this.appService.app;
  }

  async beforeModel(transition) {
    if (this.app.cannotSeeDeprecatedReports) {
      this.customReportsService.routeToOverviewPage();
    } else {
      this.intercomEventService.trackAnalyticsEvent({
        action: 'redirected',
        object: this.reportName,
        context: this.reportContext,
        section: 'reports',
        place: this.analytics.place,
      });
      this.router.transitionTo('apps.app.reports.customer-support.team-performance');
    }
  }

  async model(_, transition) {
    let settings = this._fetchReportingSetting();
    let conversationAttributeDescriptors =
      await ConversationAttributeDescriptor.peekAllAndMaybeLoad();

    return hash({
      settings,
      conversationAttributeDescriptors,
      launchPaywall: transition.to.queryParams.paywall,
    });
  }

  _fetchReportingSetting() {
    return (
      this.store.peekAll('reporting/settings')?.firstObject ||
      this.store.queryRecord('reporting/settings', {})
    );
  }
}
